import React, { FC, useState } from 'react';
import { ForgotPasswordCont } from './ForgotPassword.styles';
import ResetPasswordConfirm from '../../components/ResetPassword/ResetPasswordConfirm/ResetPasswordConfirm';
import ResetPasswordForm from '../../components/ResetPassword/ResetPasswordForm/ResetPasswordForm';
import { useResetPassword } from '../../hooks/useResetPassword';
import { IResetPassLinkRequest } from '../../services/resetPassword';

const ForgotPassword: FC = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { resetPassword } = useResetPassword();

  const reset = (email: IResetPassLinkRequest) => {
    setIsConfirmed(true);
    resetPassword(email);
  };

  return (
    <ForgotPasswordCont>
      {!isConfirmed ? <ResetPasswordForm reset={reset} /> : <ResetPasswordConfirm />}
    </ForgotPasswordCont>
  );
};

export default ForgotPassword;
